// Optional gift recipient email on the product form (snippets/gift-recipient-field.liquid).
//
// The email input stays disabled while the box is unticked, so an address typed
// and then abandoned is never added to the cart. With the box ticked, a missing
// or malformed address stops the add to cart before product-form.js sends it:
// the product form is novalidate, so nothing else would check it.
if (!customElements.get('gift-recipient-field')) {
  customElements.define(
    'gift-recipient-field',
    class GiftRecipientField extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.email = this.querySelector('input[type="email"]');
        this.email.required = true;

        this.checkbox.addEventListener('change', () => {
          this.sync();
          if (this.checkbox.checked) this.email.focus();
        });
        this.sync();

        // Capture on <product-form> runs before product-form.js's own submit
        // listener on the inner <form>, so stopping here cancels the add.
        this.closest('product-form')?.addEventListener('submit', this.onSubmit.bind(this), true);
      }

      sync() {
        this.email.disabled = !this.checkbox.checked;
      }

      onSubmit(evt) {
        if (this.email.disabled) return;
        this.email.value = this.email.value.trim();
        if (this.email.checkValidity()) return;
        evt.preventDefault();
        evt.stopPropagation();
        this.email.reportValidity();
      }
    }
  );
}
